module.exports = __webpack_public_path__ + "static/ogre_goblin_hucker-05f74014d419e13d7c04884406d0b212.png";